;(function ( $, undefined ) {

	function HeroImages ( element ) {

		var defaultSettings = {};

		if(typeof(defaults) != 'undefined') {
			defaultSettings = defaults; 
		}

		this.element = element;
		this.options = $.extend( {}, defaultSettings, this.options );

		this.init();
	}


	HeroImages.prototype = {

		init       : function () {
			var _this = this;


			_this.$elem = $(  this.element );

				_this.$img = _this.$elem.find( '.hero__image' );
				_this.$heroContent = _this.$elem.find( '.hero__content' );
				_this.hasImage = _this.$img.length > 0;
				_this.verticalBuffer = 40; // $gutter @ top + @bottom
				_this.imgSrc;
				_this.currImageHeight;
				_this.contentNeededSize;
				_this.currImgMode = 'img';


			_this.switchIt();
			_this.bindEvents();

		},
		bindEvents : function () {
			var _this = this;


			// On resize
			var debouncedResize = debounce( function () {
				_this.switchIt();
			}, 250 );

			window.addEventListener( 'resize', debouncedResize );

		},
		switchIt   : function () {
			var _this = this;

			_this.getImageInfo();
			_this.calculateContentSize();


			// console.log( 'currImageHeight', currImageHeight, 'contentNeededSize', contentNeededSize );

			// Image is taller
			if ( _this.currImageHeight >= ( _this.contentNeededSize + _this.verticalBuffer ) && _this.currImgMode != 'img' ) {

				//	console.log( 'Switching to img mode' );
				_this.switchBgToImg();

			} else if ( _this.currImageHeight < ( _this.contentNeededSize + _this.verticalBuffer) && _this.currImgMode != 'bg' ) {

				//	console.log( 'Switching to bg mode' );
				_this.switchImageToBg();

			}

		},

		// Sized by content
		switchImageToBg : function () {
			var _this = this;


			_this.$elem.css( {
				'background-image' : 'url(' + _this.imgSrc + ')'
			} );
			_this.$img.hide();
			_this.currImgMode = 'bg';

			_this.$heroContent.css( 'position', 'relative' );

			// Some contents have INNER content that is absolutely positioned
			if ( _this.$elem.hasClass( 'hero--right-aligned' ) || _this.$elem.hasClass( 'hero--bottom-aligned' ) ) {
				_this.$elem.find( '.hero__content' ).find( '.wrapper' ).each( function () {
					$( this ).css( 'position', 'relative' );
				} );
			}


			if ( _this.$elem.hasClass( 'container--has-video' ) ) {
				// Saving the padding for later in case we need to revert back to desktop mode
				_this.$elem.data( 'original-padding-bottom', ( _this.$elem.outerHeight() / _this.$elem.outerWidth() * 100 ) + '%' );

				_this.$elem.css( {
					'height'         : 'auto',
					'padding-bottom' : 0
				} );
			}

			_this.$elem.addClass( 'bg-mode' );
		},

		// Sized by image
		switchBgToImg        : function () {
			var _this = this;


			_this.$elem.css( {
				'background-image' : 'none'
			} );
			_this.$img.show();
			_this.currImgMode = 'img';

			_this.$heroContent.css( 'position', 'absolute' );

			// Some contents have INNER content that is absolutely positioned
			if ( _this.$elem.hasClass( 'hero--right-aligned' ) || _this.$elem.hasClass( 'hero--bottom-aligned' ) ) {
				_this.$elem.find( '.hero__content' ).find( '.wrapper' ).each( function () {
					$( this ).css( 'position', 'absolute' );
				} );
			}


			if ( _this.$elem.hasClass( 'container--has-video' ) ) {
				var originalPaddingBottom = _this.$elem.data( 'original-padding-bottom' );

				_this.$elem.css( {
					'height'         : 0,
					'padding-bottom' : originalPaddingBottom
				} );
			}

			_this.$elem.removeClass( 'bg-mode' );
		},
		getImageInfo         : function () {
			var _this = this;

			if ( !_this.hasImage ) {
				return;
			}

			if ( !_this.imgSrc ) {
				_this.imgSrc = _this.$img[ 0 ].src;
			}

			var isImageHidden = !_this.$img.is( ':visible' );

			// In video containers, the image is usually set to absolute
			// We need to adjust it for a second to get its real size
			if ( isImageHidden ) {
				_this.$img.show();

				if ( _this.$elem.hasClass( 'container--has-video' ) ) {
					_this.$img.css( {
						'position' : 'relative',
						'height'   : 'auto',
					} );
				}
			}

			_this.currImageHeight = _this.$img.outerHeight();

			// In video containers, the image is usually set to absolute
			// We need to adjust it for a second to get its real size
			// ..and now we need to revert it to its original css
			if ( isImageHidden ) {
				_this.$img.hide();

				if ( _this.$elem.hasClass( 'container--has-video' ) ) {
					_this.$img.css( {
						'position' : 'absolute',
						'height'   : '100%',
					} );
				}
			}

		},
		calculateContentSize : function () {
			var _this = this;

			var $currHeight = _this.$elem.outerHeight();

			var $contentClone = _this.$elem.clone().css( {
				'position' : 'fixed',
				'top'      : -9999,
				'left'     : 0,
				'width'    : '100%'
			} ).appendTo( 'body' );

			var $clonedHeroContent = $contentClone.find( '.hero__content' );
			$clonedHeroContent.css( 'position', 'relative' );

			// Some contents have INNER content that is absolutely positioned
			if ( $contentClone.hasClass( 'hero--right-aligned' ) || $contentClone.hasClass( 'hero--bottom-aligned' ) ) {
				$clonedHeroContent.find( '.wrapper' ).each( function () {
					$( this ).css( 'position', 'relative' );
				} );

			}


			_this.contentNeededSize = $clonedHeroContent.outerHeight();

			$contentClone.remove();
		}
	}

		// A really lightweight plugin wrapper around the constructor,
		// preventing against multiple instantiations
		$.fn.heroImages = function ( options ) {
			return this.each( function () {
				if ( !$.data( this, "HeroImages" ) ) {
					$.data( this, "HeroImages", new HeroImages( this, options ) );
				}
			} );
		}

})( jQuery );